<template>
  <section class="section">
    <div class="container">
      <div class="row align-items-center">
        <!-- 左側: テキスト -->
        <div class="col-md-6 pickup-text fade-in-up">
          <h2 class="pickup-title">通知が来たら、受け取るだけ。</h2>
          <ul class="pickup-points">
            <li>
              <i class="bi bi-chat-dots"></i>
              通知はLINEでシンプル
            </li>
            <li>
              <i class="bi bi-geo-alt-fill"></i>
              群馬大学 桐生キャンパス内の所定の位置
            </li>
          </ul>
          <!-- LINE通知モック -->
          <div class="line-notification fade-in-up delay-2">
            <div class="line-notification-icon">
              <i class="bi bi-chat-fill"></i>
            </div>
            <div class="line-notification-body">
              <span class="line-notification-label">LINE</span>
              <p class="line-notification-text">お弁当が到着しました！</p>
            </div>
            <span class="line-notification-time">今</span>
          </div>
        </div>
        <!-- 右側: 画像 -->
        <div class="col-md-6 fade-in-up delay-3">
          <img src="/img/top/place.jpg" alt="受け取り場所" class="pickup-img">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionPickup',
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables';
@import '@/assets/scss/mixins';

.pickup-title {
  font-size: $font-size-section-title;
  font-weight: 700;
  color: $color-text;
  margin-bottom: 1.5rem;

  @include media-down(768px) {
    font-size: 1.5rem;
    text-align: center;
  }
}

.pickup-points {
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;

  li {
    font-size: $font-size-body;
    color: $color-text;
    margin-bottom: 0.75rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;

    i {
      color: $color-primary;
      font-size: 1.25rem;
      flex-shrink: 0;
    }
  }

  @include media-down(768px) {
    li {
      justify-content: center;
    }
  }
}

// LINE通知UIモック
.line-notification {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background-color: #fff;
  border: 2px solid $color-line;
  border-radius: $border-radius-base;
  padding: 1rem 1.25rem;
  max-width: 380px;
  box-shadow: 0 4px 16px rgba($color-line, 0.15);
  position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba($color-line, 0.2);
  }

  @include media-down(768px) {
    max-width: 100%;
    margin: 0 auto;
  }
}

.line-notification-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: $color-line;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.line-notification-body {
  flex: 1;
}

.line-notification-label {
  font-size: $font-size-small;
  color: $color-line;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.line-notification-text {
  font-size: $font-size-body;
  color: $color-text;
  margin-bottom: 0;
  font-weight: 600;
}

.line-notification-time {
  font-size: $font-size-small;
  color: $color-text-light;
  align-self: flex-start;
  flex-shrink: 0;
}

.pickup-img {
  width: 100%;
  height: auto;
  border-radius: $border-radius-lg;
  object-fit: cover;

  @include media-down(768px) {
    margin-top: 2rem;
  }
}
</style>
